// extracted by mini-css-extract-plugin
export default {"secondary-column-cell":"secondary-column-cell_Lhijr","secondaryColumnCell":"secondary-column-cell_Lhijr","arrow":"arrow_L2_mg","disabled":"disabled_XVwU2","divider":"divider_gnzK3"};